import { validUrl } from '../components/Contact/regex';

/**
 * Performs an external redirect to the provided URL, or throws an error if it is not a valid URL
 * @param url The URL to redirect to
 * @example safeExternalRedirect('https://www.clover.com/');
 */
export const safeExternalRedirect = (url: string) => {
  if (!validUrl.test(url)) {
    console.error(`Unable to redirect to Url as it is not a valid Url: ${url}`);
    return;
  }
  window.location.replace(url);
};
